import { render, staticRenderFns } from "./FullPageDigiStudentDashboard.vue?vue&type=template&id=473dc844&"
import script from "./FullPageDigiStudentDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiStudentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiStudentDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports